import React from 'react';

const StampCard = React.lazy(() => import('./StampCard'));
const ViewStampCard = React.lazy(() => import('./ViewStampCard'));

export const stampCardPagesConfigs = [
  {
    path: '/stamp-card',
    element: <StampCard />,
  },
  {
    path: '/stamp-card/:id',
    element: <ViewStampCard />,
  },
];
